module.exports = __webpack_public_path__ + "img/jiaoyu.6d13c54d.jpg";